export default [
  {
    path: '/',
    name: 'home',
    label: '首页',
    component: () => import('@/view/home/home'),
  },
  {
    path: '/hospitalPreparations',
    name: 'hospitalPreparations',
    label: '院内制剂',
    component: () => import('@/view/hospitalPreparations/hospitalPreparations'),
  },
  {
    path: '/hospitalPreparations/:id',
    name: 'hospitalPreparations',
    label: '产品详情',
    notShow: true,
    component: () => import('@/view/hospitalPreparations/details/details'),
  },
  {
    path: '/about',
    name: 'about',
    label: '关于我们',
    component: () => import('@/view/about/about'),
  },
  {
    path: '/joinInvestment',
    name: 'joinInvestment',
    label: '招商加盟',
    component: () => import('@/view/joinInvestment/joinInvestment'),
  },
];
// 首页



// WEBPACK FOOTER //
// ./src/router/home.js